import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { AnswerType5, QuizQuestion } from '../../shared/types';
import { diffChars } from 'diff';
import Select from 'react-dropdown-select';

type Props = {
  data: QuizQuestion;
  isSubmitted: boolean;
  currentAnswer: string;
  setCurrentAnswer: (val: string) => void;
};

const speedOptions = [
  { id: 0.5, name: '0.5x' },
  { id: 1, name: '1x' },
  { id: 1.5, name: '1.5x' },
  { id: 2, name: '2x' },
];

export const CardTemplate14: FC<Props> = ({ data, isSubmitted, currentAnswer, setCurrentAnswer }) => {
  const [speedRate, setSpeedRate] = useState<number>(1);
  const audioRef = useRef<HTMLAudioElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCurrentAnswer(e.target.value);
  };

  const renderResulBlock = useCallback(() => {
    const resultBlock = document.getElementById('dictant-result-block');
    const diff = diffChars((data?.paramjs as AnswerType5)?.answer, currentAnswer);
    const display = document.getElementById('display');
    const fragment = document.createDocumentFragment();

    diff.forEach((part) => {
      // green for additions, red for deletions
      // grey for common parts
      const color = part.added ? 'red' : part.removed ? 'red' : 'green';
      const span = document.createElement('span');
      span.style.color = color;
      span.appendChild(document.createTextNode(part.value));
      fragment.appendChild(span);
    });

    resultBlock?.appendChild(fragment);
    return resultBlock;
  }, [data, currentAnswer]);

  useEffect(() => {
    if (isSubmitted) {
      renderResulBlock();
    }
  }, [isSubmitted]);

  useEffect(() => {
    if (!!audioRef.current) {
      audioRef.current.playbackRate = speedRate;
    }
  }, [speedRate]);

  return (
    <div className="text-center">
      <h4 className="h3 tw-underline">{data.qs_main}</h4>
      <div className="tw-flex tw-items-center tw-gap-2 tw-mt-5">
        <audio
          ref={audioRef}
          src={'https://saryarqatil.kz/edit/lib/audio/' + data?.main_audio}
          controls
          controlsList="nodownload noplaybackrate"
          className="tw-flex-grow"
        />
        {/*// @ts-ignore*/}
        <Select
          valueField="id"
          labelField="name"
          values={[speedOptions.find((val) => val.id === speedRate) as { id: number; name: string }]}
          onChange={(newValue) => setSpeedRate(newValue[0].id)}
          options={speedOptions}
          className={`tw-h-[38px] tw-text-xl sm:tw-text-xl [&_.react-dropdown-select-dropdown-handle]:tw-h-[40px] [&_.react-dropdown-select-dropdown]:tw-w-auto !tw-border-0`}
          searchable={false}
          placeholder=""
          closeOnSelect
        />
      </div>
      <p className="tw-mt-3 tw-text-xl sm:tw-text-2xl">{data.qs_dsc}</p>
      <div className="tw-my-5 sm:tw-min-w-[700px]">
        <div id="dictant-result-block" className="tw-text-left tw-p-2 tw-text-lg" />
        {!isSubmitted && (
          <textarea
            spellCheck={false}
            className={`tw-w-full tw-text-lg sm:tw-text-xl border border-1 border-gray bg-white rounded-1 px-4 py-2`}
            value={currentAnswer}
            onChange={handleChange}
            rows={6}
          />
        )}
      </div>
    </div>
  );
};
